export default {
  title: '{{plan}} está activo',
  plan: 'Plan: {{plan}}',
  free_until: 'Gratis hasta {{date}}',
  continue: 'Continuar',
};
